import React, { useState } from "react";
import Header from "./components/Header";
import Featured from "./components/Featured";
import Hero from "./components/Hero";
import Where from "./components/Where";
import How from "./components/How";
import What from "./components/What";
import Join from "./components/Join";
import Be from "./components/Be";

function App() {
  const [activeLang, setActiveLang] = useState("html");

  return (
    <>
      <Header/>
      <Hero/>
      <Featured/>
      <Where/>
      <How/>
      <Be/>
      <What/>
      <Join/>
    </>
  );
}

export default App;
